import { IconButton } from "@/components/interactive/IconButton";
import { Tooltip } from "@/components/TooltipV2";
import { useTheme } from "next-themes";
import React, { useEffect, useState } from "react";

export const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const isDark = theme === "dark";

  return (
    <Tooltip content={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      <IconButton
        iconName={isDark ? "sun" : "moon"}
        iconClassName={"h-[14px] w-[14px] min-h-[14px] min-w-[14px]"}
        size="sm"
        color="secondary"
        onClick={() => setTheme(isDark ? "light" : "dark")}
      />
    </Tooltip>
  );
};
